import React from 'react';

const Connect: React.FC = () => {
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        alert('В процессе разработки');
    };

    return (
        <div className="connect">
            <div className="container">
                <div className="decisions__i-body connect__content">
                    <h2 className="t-two connect__title">
                        Подпишитесь на рассылку, чтобы быть
                        в курсе акций и специальных предложений
                    </h2>
                    <div className="d-flex flex-column connect__bot flex-xl-row justify-content-between">
                        <form action="#" className="d-flex flex-column flex-md-row connect__form" onSubmit={handleSubmit}>
                            <div className="form-control-item">
                                <input type="email" className="form-control" name="_email" placeholder="E-mail"/>
                            </div>
                            <button type="submit" className="btn btn-primary big connect__btn">Продолжить</button>
                        </form>

                        <div className="d-flex flex-column flex-md-row align-items-md-center connect__right">
                            <p>или следите за нами в социальных сетях</p>
                            <div className="d-flex connect__social">
                                <a
                                    className="d-flex align-items-center justify-content-center"
                                    href="https://www.youtube.com/@pridegroup957"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img className="w-100" src="images/yb.svg" alt="YouTube"/>
                                </a>
                                <a
                                    className="d-flex align-items-center justify-content-center"
                                    href="https://vk.com/prideth"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img className="w-100" src="images/vk.svg" alt="VK"/>
                                </a>
                                <a className="d-flex align-items-center justify-content-center" href="#">
                                    <img className="w-100" src="images/tel.svg" alt="Telegram"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Connect;